import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PositionsTable from '@components/PositionsTable/PositionsTable';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { APP_TEXTS } from '../../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../../src/texts/tooltips';
import Input from '@components/Input';

class SpacingSquareBase extends Component {

  static propTypes = {
    options: PropTypes.object.isRequired, // eslint-disable-line
    onUpdate: PropTypes.func.isRequired,
    setCustomCoordinates: PropTypes.func.isRequired
  };

  render() {
    return (
      <div>
        <div className="base-plate__row">
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_SPACING_BETWEEN_AMCHORS.Content}>
            <Input
              name="s1"
              prefix="S1 ="
              postfix={unitLabel(this.props.unit)}
              disabled={this.isS1Disabled()}
              className="base-plate__input _inline-block"
              id="s1"
              type="number"
              minValue={0}
              value={unitTransform(this.props.options.padding.s1 || 0).from(defaultUnits.DISTANCE).to(this.props.unit) || 0}
              onUpdate={this.updateS1}
            />
          </Tooltip>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_SPACING_BETWEEN_AMCHORS.Content}>
            <Input
              name="s2"
              prefix="S2 ="
              postfix={unitLabel(this.props.unit)}
              disabled={this.isS2Disabled()}
              className="base-plate__input _inline-block"
              id="s2"
              type="number"
              minValue={0}
              value={unitTransform(this.props.options.padding.s2 || 0).from(defaultUnits.DISTANCE).to(this.props.unit) || 0}
              onUpdate={this.updateS2}
            />
          </Tooltip>
        </div>

        { this.props.options.custom && this.props.options.custom.allow && (
          <div>
            <div className="input-group mt-2 w-50">
              <div className="input-group-prepend">
                <span className="input-group-text" id="">N x P</span>
              </div>
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_INPUT_FIXINGS_EACH_ROW.Content}>
              <Input
                id="N"
                type="number"
                placeholder="nb_x"
                minValue={1}
                maxValue={25}
                disabled={this.props.specifyCoordinates}
                value={this.props.options.count.n}
                onUpdate={(e) => {
                  this.updateScrewCount(e, 'n');
                }}
              />
              </Tooltip>

              <Tooltip content={APP_TOOLTIPS.TOOLTIP_INPUT_FIXINGS_EACH_COLUMN.Content}>
              <Input
                id="P"
                type="number"
                placeholder="nb_y"
                minValue={1}
                maxValue={25}
                disabled={this.props.specifyCoordinates}
                value={this.props.options.count.m}
                onUpdate={(e) => {
                  this.updateScrewCount(e, 'm');
                }}
              />
              </Tooltip>
            </div>

            <div className="form-check">
              <label className="form-check-label m-2" htmlFor="specify">
                <input
                  className="form-check-input"
                  id="specify"
                  type="checkbox"
                  checked={this.props.specifyCoordinates}
                  onChange={(e) => {
                    this.updateCustomActive(e.target.checked);
                  }}
                />
               {APP_TEXTS.SPACING_SPECIFY_COORDINATES.Content}
              </label>
            </div>

            <div className="w-50">
              <PositionsTable
                isDisabled={!this.props.specifyCoordinates}
                onUpdate={this.props.onUpdate}
                positions={this.props.options.coordinatesList}
                maxLength={625}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  updateCustomActive(active) {
    if (active === true){
      this.props.onUpdate({
        custom: {
          active,
          positions: this.props.options.coordinatesList//.map(pos => new THREE.Vector3(pos.x, pos.y * -1, pos.z))
        }
      });
    } else {
      this.props.onUpdate({
        custom: {
          active
        }
      });
    }

    this.props.setCustomCoordinates(active);
  }

  updateScrewCount = (value, dir) => {
    this.props.onUpdate({
      count: {
        [dir]: window.parseInt(value > 25 ? 25 : value)
      }
    });
  };

  updateS1 = (value) => {
    this.props.onUpdate({
      padding: {
        s1: unitTransform(+value, false).from(this.props.unit).to(defaultUnits.DISTANCE)
      }
    });
  };

  updateS2 = (value) => {
    this.props.onUpdate({
      padding: {
        s2: unitTransform(+value, false).from(this.props.unit).to(defaultUnits.DISTANCE)
      }
    });
  };

  isS1Disabled = () => {
    if ((this.props.specifyCoordinates) || this.props.options.count.n === 1 || 
      (this.props.predefinedBasePlate && this.props.predefinedBasePlate.isPredefinedBasePlate))
      return true;
    else 
      return false;
  }

  isS2Disabled = () => {
    if ((this.props.specifyCoordinates) || this.props.options.count.m === 1 || 
    (this.props.predefinedBasePlate && this.props.predefinedBasePlate.isPredefinedBasePlate))
      return true;
    else 
      return false;
  }

}

const mapState = state => {
  const unit = state.main.units.distance;
  const specifyCoordinates = (state.selectors.dimension[state.main.appType].basePlate && 
    state.selectors.dimension[state.main.appType].basePlate.spacing && 
    state.selectors.dimension[state.main.appType].basePlate.spacing.specifyCoordinates) || false;

  return {
    unit,
    specifyCoordinates,
    predefinedBasePlate: state.selectors.application[state.main.appType].predefinedBasePlate
  };
};

export default connect(mapState)(SpacingSquareBase);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/Spacing/SpacingSquareBase.js